import { GlobalSearchResultModel } from '../global-search/global-search-result';
export const isBookmarkModel = (item) => typeof item.id !== 'undefined';
export class BookmarkModel extends GlobalSearchResultModel {
    id;
    accountId;
}
//# sourceMappingURL=bookmarkModel.js.map